module.exports = __webpack_public_path__ + "static/media/all-day-breakfast-hero-mobile.8125a4fb.jpg";